module.exports = __webpack_public_path__ + "img/top1.ab9ef2d1.png";